<template>
    <div class="product-card product-card-grid" :id="product.entity_code" v-if="product.visible"
         :class="{active: isActive}" @mouseleave="disactiveCard" @mouseenter="stopDisactiveCard">
        <div class="product-card-grid-header">
            <Tags v-bind:product="product" :key="product.id"></Tags>
            <div class="product-card-title product-card-grid-title">
                {{ product.title }}
            </div>
            <div class="zoom" @click="openLargeCard(catalogElement)" :ref="product.code" :id="product.code">
              <span class="pp-icon pp-icon-loupe"></span>
            </div>
            <div class="product-card-grid-image" :style="{ backgroundImage: `url(${productSmallCardImage})` }">
                <div class="product-card-like" @click="setVote" :class="{'button-processing': voteButtonProcessing}">
                    <span class="like-qnt">{{ product.votes }}</span>
                    <span class="like-button pp-icon" :class="[ userVote > 0 ? 'pp-icon-heart-full' : 'pp-icon-heart']"></span>
                </div>
            </div>

            <DescriptionTemplate v-if="isPizzaOrSaladDesktopNoActiveCard()" :title="''" :description="product.consist"/>

            <DescriptionTemplate v-if="isPizzaOrActiveSaladMobileCard()" :title="''" :description="product.consist"/>

            <DescriptionTemplate v-if="isNoActiveSaladMobileCard()"
                                 :title="phrases.TEXT_WEIGHT" :description="product.weight + ' ' + phrases.PRODUCT_WEIGHT_GR_DOT"/>

            <DescriptionTemplate v-if="isNoActiveSnackWithSloganCard()"
                                 :description="product.slogan" :css-class="'product-slogan'"/>

            <DescriptionTemplate v-if="isDrinksNoActiveMobileWithWeightCard()"
                                 :title="phrases.TEXT_VOLUME" :description="product.weight + ' ' + phrases.PRODUCT_VOLUME_L_DOT"/>

            <DescriptionTemplate v-if="isSnackOrDrinksActiveMobileWithConsistCard()"
                                 :title="phrases.PRODUCT_CONSIST" :description="consist"/>

            <DescriptionTemplate v-if="isCakeActiveOrDesktopWithSloganCard()"
                                 :description="product.slogan"/>

            <DescriptionTemplate v-if="isCakeNoActiveMobileWithWeightCard()"
                                 :title="phrases.TEXT_WEIGHT" :description="product.weight + ' ' + phrases.PRODUCT_WEIGHT_GR_DOT"/>

            <DescriptionTemplate v-if="isSnackMobileWithWeightCard()"
                                 :title="phrases.TEXT_WEIGHT" :description="getWeight(product, selectedOffer.id) + ' ' + phrases.PRODUCT_WEIGHT_GR_DOT"/>

            <div class="product-card-grid-body">
                <div class="product-card-grid-body-title">{{ product.title }}</div>
                <div v-if="isPizza && isSizeMd" class="product-card-grid-body-weight">
                  <span class="product-card-grid-body-weight-title">{{ phrases.TEXT_WEIGHT }}:</span> {{ getPizzaWeight(product, selectedOffer.id) }}{{ phrases.PRODUCT_WEIGHT_GR }}
                </div>
              <div class="product-card-grid-body-price">{{ getPrice(product, selectedOffer.id) }}&#8381;</div>
            </div>
        </div>

        <div class="product-card-grid-buttons" v-if="isPizza && product.offers.length > 0">

            <div class="button-unavailable" v-if="!product.available">{{phrases.PRODUCT_UNAVAILABLE}}</div>

            <div v-else v-for="offer in product.offers" :key="offer.id" class="product-choose-button button-sm"
                 @click="choosePizzaSize(offer)" :class="{'blocked': !offer.available}">
                <div class="button-price">{{offer.price}}&#8381;</div>
                <div class="button-note">{{offer.size}}{{phrases.PRODUCT_PIZZA_DIAMETR_UNIT}}</div>
            </div>
        </div>

        <div class="product-card-grid-buttons" v-else>
            <div class="product-choose-button button-lg" @click="chooseProduct()" v-if="product.available">
                <span class="button-value">{{ phrases.PRODUCT_CARD_BUTTON_BUY }}</span>
                <span class="button-price">{{ product.price_from }}&#8381;</span>
            </div>
            <div class="button-unavailable" v-else>{{phrases.PRODUCT_UNAVAILABLE}}</div>
        </div>

        <div class="product-card-grid-footer" ref="footer">

            <div class="product-card-option" v-if="isPizza">
                <div class="product-card-option-title" v-if="selectedOffer.dough_available === true">{{ optionsTitle(product) }}</div>
                <div class="product-card-option-list" v-if="selectedOffer.dough_available === true">
                    <div class="product-card-option-button size-lg" :class="{active: isThinDough}"
                         @click="changeDoughType(true)">{{ doughTitle('thin')}}</div>
                    <div class="product-card-option-button size-lg" :class="{active: !isThinDough}"
                         @click="changeDoughType(false)">{{ doughTitle('thick')}}</div>
                </div>
            </div>

            <div class="product-card-option" v-else-if="isSauce">
                <div class="product-card-option-title">{{ optionsTitle(product) }}</div>
                <div class="product-card-option-list option-list-sm">
                    <div class="product-card-option-button size-sm"
                         v-for="offer in product.offers" :key="offer.id"
                         :class="{active: selectedOffer.id === offer.id, 'blocked': !offer.available}"
                         @click="chooseSauceOffer(offer)" >
                        {{ offer.title }}
                    </div>
                </div>
            </div>

            <div class="product-card-option" v-else-if="product.offers.length > 0">
                <div class="product-card-option-title">{{ optionsTitle(product) }}</div>
                <div class="product-card-option-list option-list-sm">
                    <div class="product-card-option-button" v-for="offer in product.offers" :key="offer.id"
                         @click="chooseOffer(offer)" :class="{active: selectedOffer.id === offer.id}">
                        {{ offer.title }}
                    </div>
                </div>
            </div>

            <div class="product-card-option" v-else-if="product.offers.length === 0"></div>

            <div v-if="isAvailable" class="product-card-button-action goal-add-product-to-basket"
                 :class="[addedToBasket ? 'active' : '']" @click="addToBasket()">
                <span class="pp-icon pp-icon-basket-move"></span>
                <span class="product-card-button-action-title">{{phrases.PRODUCT_CARD_BUTTON_ADD_TO_CARD}}</span>
            </div>

            <div v-else class="product-card-button-action unavailable">{{phrases.PRODUCT_UNAVAILABLE}}</div>
        </div>
    </div>
</template>

<script>
    import Utils from "../Utils.vue";
    import ProductCard from "./ProductCard.vue";
    import Tags from "@/components/product/Tags.vue";
    import {mapGetters} from "vuex";
    import DescriptionTemplate from "../product/DescriptionTemplate.vue";
    import CatalogUtils from "@/components/catalog/CatalogUtils.vue";

    export default {
        name: "ProductCardSmall",
        components: {
          DescriptionTemplate,
          Tags,
        },
        props: {
            catalogElement: {},
        },
        methods: {
          isPizzaOrSaladDesktopNoActiveCard: function (){
            return (this.isPizza || this.isSalad) && !this.isSizeMd && !this.isActive;
          },
          isPizzaOrActiveSaladMobileCard: function (){
            return (this.isPizza || (this.isSalad && this.isActive)) && this.isSizeMd;
          },
          isNoActiveSaladMobileCard: function (){
            return this.isSalad && this.isSizeMd && !this.isActive;
          },
          isNoActiveSnackWithSloganCard: function (){
            return this.isSnack && !this.isActive && this.product.slogan !== null;
          },
          isSnackMobileWithWeightCard: function (){
            return this.isSnack && this.isSizeMd && this.weight !== null;
          },
          isDrinksNoActiveMobileWithWeightCard: function (){
            return this.isDrinks && !this.isActive && this.isSizeMd && this.product.weight !== null;
          },
          isSnackOrDrinksActiveMobileWithConsistCard: function (){
            return ((this.isDrinks || this.isSnack) && this.isActive && this.isSizeMd && this.consist !== null);
          },
          isCakeActiveOrDesktopWithSloganCard: function (){
            return (this.isCake && (this.isActive || !this.isSizeMd) && this.product.slogan !== null);
          },
          isCakeNoActiveMobileWithWeightCard: function (){
            return (this.isCake && !this.isActive && this.isSizeMd && this.product.weight !== null);
          }
        },
        computed:{
          isActiveConsist: function (){
            return this.product.consist && (!this.isSizeMd && !this.isSnack || (this.isActive && this.isSizeMd));
          },
          ...mapGetters('app', {
            isSizeMd: 'getIsSizeMd',
          }),
          product: function (){
            return this.catalogElement.element;
          },
        },
        mounted() {
          const component = this;
          if (component.entityInUrlPath(component.catalogElement)){
            component.openLargeCard(component.catalogElement);
          }
        },
        mixins: [Utils, ProductCard, CatalogUtils],
    }
</script>

<style scoped lang="scss">
.product-card-grid-body-weight{
  margin-bottom: 0.3em;
  &-title{
    font-family: Panton Bold;
    margin: 0 0.25rem 0 0;
  }
}
.product-card-option-button{
  &.blocked{
    cursor: default;
    background: #809f36;
    color: #ffffff;
    opacity: 0.7;
    &:hover{
      background: #809f36;
      color: #fff;
    }
  }
}
@media all and (max-width: 991px) {
  .product-slogan{
    margin: 0 0 0.25rem 0;
  }
}
@media all and (min-width: 921px) {
  .product-card-grid-footer{
    .product-card-grid-consist{
      display: none;
    }
  }
}

</style>
